import { IClause } from "@/api";
import { LinkRouter } from "@/components/shared/buttons/LinkRouter";

interface IProps {
    /**
     * Clause to display details for.
     */
    clause: IClause;
}

/**
 * Link that navigates to the clause details page.
 */
export const ClauseDetailsButton = ({ clause }: IProps) => {
    return (
        <LinkRouter to={`/admin/clauses/${clause.id}/details`}>
            {clause.title}
        </LinkRouter>
    );
};
